import React, { useEffect, useRef, useState } from "react";
import Card from "../../../components/Card";
import Loader from "../../../components/Loader";
import Modal from "../../../components/Modal";
import { UseApi } from "../../../hooks/use-api";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import { GetNFTTemplates } from "../../../Services/lib/nfttemplates";
import styles from "./CreateCollection.module.sass";
import Empthy from "../../../components/Empty";
import cn from "classnames";
import TextInput from "../../../components/TextInput";
import collection from "../../../i11/Collection";
import { useUser } from "../../../context";

const converter = (E) => {
	const tmp = {};
	E.forEach((element) => {
		tmp[element._id] = element;
	});
	return tmp;
};

const TemplateSelector = ({
	setReqBody,
	initial = [],
	initialData = [],
	reqBody,
}) => {
	const { locale } = useUser();
	const { onOpen, onClose, isOpen } = UseDisclosure();
	const [selected, setSelected] = useState(initial);
	const [products, setProducts] = useState({});
	const [tmpData, setTmpData] = useState(converter(initialData));
	const tmpdateBup = useRef(converter(initialData));
	const initialRef = useRef(initial);
	const [name, setname] = useState("");

	const [{ isLoading }, getNFTs] = UseApi({
		service: GetNFTTemplates,
	});

	const get = async (name__) => {
		const res = await getNFTs({
			offset: 0,
			limit: 12,
			name: name__,
			sortBy: "updatedAt",
			orderBy: "desc",
			status: "EVERY",
		});
		if (res) {
			const tmp = converter(res.nftTemplates);
			setProducts(tmp);
		}
	};

	useEffect(() => {
		get("");
	}, []);

	const add = (e) => {
		setTmpData((p) => {
			return {
				...p,
				[e]: products[e],
			};
		});
		setSelected((p) => {
			return [...p, e];
		});
	};
	const remove = (e) => {
		const tmp = { ...tmpData };
		delete tmp[e];
		setTmpData(tmp);
		setSelected((p) => {
			return p.filter((e_) => e !== e_);
		});
	};

	const Confirm = () => {
		const allElem = [
			...selected.filter((i) => !initial.includes(i)),
			...initial.filter((i) => !selected.includes(i)),
		];
		const removeTemplates = [
			...initial.filter((i) => !selected.includes(i)),
			...(reqBody?.removeTemplates || []),
		];
		const addTemplates = [
			...selected.filter((i) => !initial.includes(i)),
			...(reqBody?.addTemplates || []),
		];
		let body = {};

		if (reqBody._id) {
			body = {
				removeTemplates,
				addTemplates,
				nftTemplates: selected,
			};
		} else {
			body = { nftTemplates: selected };
		}

		console.log("body create up ", body);

		setReqBody((p) => {
			return {
				...p,
				...body,
			};
		});
		tmpdateBup.current = tmpData;
		onClose();
	};

	const Close_ = () => {
		setSelected(initial);
		setTmpData(tmpdateBup.current);
		onClose();
	};
	return (
		<>
			<div className={styles.templateSelector}>
				<div className={styles.label___}>
					{collection[locale].products}
				</div>

				<div className={styles.templateContainer}>
					{reqBody.nftTemplates.map((e) => {
						return (
							<div key={e}>
								{tmpData[e]?.status === "DRAFT" && (
									<div>{collection[locale].draft}</div>
								)}
								<span className={styles.span}>
									{tmpData[e]?.name}
								</span>
								<img alt={e} src={tmpData[e]?.image} />
								{!initialRef.current.includes(e) && (
									<div className={styles.symbol}>
										{collection[locale].new}
									</div>
								)}
							</div>
						);
					})}
					<div>
						{
							<button
								onClick={onOpen}
								className={cn("button", styles.addremb)}
								type="button"
							>
								{collection[locale].add_remove}
								<br />
								{collection[locale].product}
							</button>
						}
					</div>
				</div>
			</div>
			<Modal
				outerClassName={styles.outerClassName}
				visible={isOpen}
				onClose={Close_}
			>
				<Card
					title={collection[locale].select_prod}
					className={styles.card___}
					classTitle="title-red"
				>
					<div className={styles.label___}>
						{collection[locale].selected_prod}
					</div>
					<div className={styles.templateContainer}>
						{selected.map((e) => {
							return (
								<div className={styles.remove} key={e}>
									{tmpData[e]?.status === "DRAFT" && (
										<div>{collection[locale].draft}</div>
									)}
									<span className={styles.span}>
										{tmpData[e]?.name}
									</span>
									<img alt={e} src={tmpData[e]?.image} />
									<div
										onClick={() => remove(e)}
										className={styles.remove}
									>
										{collection[locale].remove}
									</div>
								</div>
							);
						})}
					</div>
					<div className={styles.label___}>
						{collection[locale].products}
					</div>
					<div className={styles.input}>
						<TextInput
							className={styles.inputbody}
							placeholder={collection[locale].search_prod}
							onChangeInput={setname}
							value={name}
						/>
						<button
							className={cn("button", { disabled: isLoading })}
							type="button"
							onClick={() => {
								get(name);
							}}
						>
							{isLoading && <Loader />}
							{collection[locale].search}
						</button>
					</div>
					{isLoading ? (
						<div className={styles.wrap}>
							<Loader className={styles.loader} />
						</div>
					) : Object.keys(products).length === 0 ? (
						<Empthy title={collection[locale].no_prod} />
					) : (
						<div className={styles.templateContainer}>
							{Object.keys(products).map((e) => {
								if (!selected.includes(e))
									return (
										<div className={styles.add} key={e}>
											{products[e]?.status ===
												"DRAFT" && (
												<div>
													{collection[locale].draft}
												</div>
											)}
											<span className={styles.span}>
												{products[e]?.name}
											</span>
											<img
												alt={e}
												src={products[e]?.image}
											/>
											<div
												onClick={() => add(e)}
												className={styles.add}
											>
												{collection[locale].add}
											</div>
										</div>
									);
							})}
						</div>
					)}
					<div className={styles.foot}>
						<button onClick={Confirm} className="button">
							{collection[locale].add}
						</button>
					</div>
				</Card>
			</Modal>
		</>
	);
};
export default TemplateSelector;
